/**
 * TOSS Web Application - EnvBanner
 *
 * Полоса «ТЕСТОВЫЙ СЕРВЕР» над страницей — на любой сборке, которая смотрит не
 * в боевой API.
 *
 * Признак — адрес бэкенда, а НЕ окружение и не режим сборки. `import.meta.env.DEV`
 * здесь бесполезен: на dev-сервере лежит обычная production-сборка, так что он там
 * `false`. По той же причине бесполезен и `IsDevelopment()` на стороне API —
 * `ASPNETCORE_ENVIRONMENT=Production` выставлен на ОБОИХ серверах намеренно
 * (scripts/bootstrap-env.sh:192 и :225, объяснение в Program.cs:87-96). А вот
 * `VITE_API_URL` подставляется на билде и у dev с prod разный.
 *
 * Полоса ничего не перекрывает: класс `env-test` на `<html>` включает в
 * `index.css` правила, которые отдают ей верх страницы. Плавающая плашка на
 * этом и провалилась — и в углу, и по центру она вставала поверх чужих кнопок.
 *
 * Монтируется один раз в `App.tsx` — вне `InternalOnlyGlobals`: dev-сервер один
 * и на внутренний ЛК, и на портал заказчика, значит знать должны обе аудитории.
 */

import { useEffect } from 'react';

/** Боевой API. Всё, что не он, — тестовое окружение. */
const PRODUCTION_API_ORIGIN = 'https://api.tosspto.com';

/**
 * Сборка смотрит НЕ в боевой бэкенд.
 *
 * Сравнение по `host`, а не по строке целиком: `VITE_API_URL` может приехать со
 * слэшем на конце или с другой схемой, и полоса не должна из-за этого пропасть.
 * Неразобранный (пустой, относительный) адрес считаем тестовым — молчать про
 * тестовое окружение хуже, чем показать полосу лишний раз.
 */
function isTestApi(): boolean {
  try {
    return (
      new URL(import.meta.env.VITE_API_URL).host !==
      new URL(PRODUCTION_API_ORIGIN).host
    );
  } catch {
    return true;
  }
}

const IS_TEST_API = isTestApi();

export function EnvBanner(): JSX.Element | null {
  useEffect(() => {
    if (!IS_TEST_API) return;
    document.documentElement.classList.add('env-test');
    return () => document.documentElement.classList.remove('env-test');
  }, []);

  if (!IS_TEST_API) return null;

  // z-[10001] — выше выехавшего меню (z-[9999]) и skip-link (z-[10000]);
  // шкала --z-* в index.css кончается на 1080 и до этих двух не достаёт.
  return (
    <div
      className="pointer-events-none fixed top-0 right-0 left-0 z-[10001] flex h-[var(--env-strip-height,20px)] items-center justify-center border-b border-[var(--color-warning)] bg-[var(--color-warning-subdued)] text-3xs font-medium tracking-wide text-[var(--color-warning)]"
    >
      ТЕСТОВЫЙ СЕРВЕР
    </div>
  );
}

export default EnvBanner;
